import type {
    AnatomyBinding,
    AnatomyPart,
    AnatomyState,
    ComponentAnatomySpec,
} from "./componentAnatomy";
import { textAreaSizes } from "./componentAnatomyTextAreaSizes";
import { textAreaVariantSpecs } from "./componentAnatomyTextAreaVariants";

// Mined from designSystem/TextArea/TextArea.module.scss: the .root base block
// here, the size axis in componentAnatomyTextAreaSizes, the colour layer in
// componentAnatomyTextAreaVariants.

const parts: readonly AnatomyPart[] = [
    {
        id: "background",
        label: "Container",
        element: "background-color on .root, via --textarea-bg",
    },
    {
        id: "border",
        label: "Border",
        element: "1px border always reserved on .root, via --textarea-border",
    },
    {
        id: "label",
        label: "Text / placeholder",
        element:
            "color on .root inherited by .control, via --textarea-fg / --textarea-placeholder",
    },
    {
        id: "grip",
        label: "Resize grip",
        element:
            "11px .grip, offset 3px from the bottom-right, color via --textarea-grip-color; only while editable",
    },
    {
        id: "focusRing",
        label: "Focus ring",
        element: "box-shadow on .root while .control is focused",
    },
];

const states: readonly AnatomyState[] = [
    { id: "resting", label: "Default", selector: "" },
    {
        id: "hover",
        label: "Hover",
        selector:
            ":hover:not(:has(.control:disabled)):not([data-disabled]):not(:has(.control:read-only)):not(:has(.control:focus))",
    },
    { id: "focus", label: "Focus", selector: ":has(.control:focus)" },
    {
        id: "readOnly",
        label: "Read-only",
        selector: ":has(.control:read-only)",
    },
    { id: "disabled", label: "Disabled", selector: ":has(.control:disabled)" },
];

const sharedBindings: readonly AnatomyBinding[] = [
    { partId: "border", property: "border-width", token: "--border-width" },
    {
        partId: "border",
        property: "border-radius",
        token: "--radius-m",
        via: "--textarea-radius",
    },
    {
        partId: "grip",
        property: "color",
        token: "--border-default",
        via: "--textarea-grip-color",
    },
    {
        partId: "background",
        property: "padding-inline-end (with grip)",
        token: "--space-20",
    },
    { partId: "grip", property: "width", literal: "11px" },
    { partId: "grip", property: "height", literal: "11px" },
    { partId: "grip", property: "offset", literal: "3px" },
];

export const textAreaAnatomy: ComponentAnatomySpec = {
    label: "Text area",
    schematic: "textArea",
    rootSelector: ".root",
    variantAxisLabel: "Variant",
    parts,
    states,
    sharedBindings,
    variants: textAreaVariantSpecs,
    sizes: textAreaSizes,
};
